import { memo } from "react";
import styles from './ProcessingIndicator.module.css';
import { AppIcon } from "@/v2/lib/appIcons";

interface ProcessingIndicatorProps {
  show: boolean;
  message?: string;
  application?: string | null;
}

const ProcessingIndicator: React.FC<ProcessingIndicatorProps> = memo(({
  show,
  message = "Processing entry...",
  application
}) => {
  if (!show) return null;

  return (
    <div className={styles.processingIndicator}>
      <div className={styles.content}>
        <div className={styles.spinner}></div>
        {application && (
          <AppIcon application={application} className={styles.appIcon} />
        )}
        <span className={styles.message}>{message}</span>
      </div>
    </div>
  );
});

export default ProcessingIndicator;
